export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_02.8d62043d.jpg";